/* HOULe 2026.10.14 お取り寄せ表示（在庫0・在庫切れでも販売する設定の商品） */
(function () {
  var BTN = 'お取り寄せで購入';
  var LBL = 'お取り寄せ';
  var NOTE = '<strong>お取り寄せ商品</strong>です。メーカーから取り寄せてからの発送となるため、ご注文から発送まで<strong>3〜5日程度</strong>いただきます。';
  var CSS = '.houle-backorder-note{margin:0 0 12px;padding:10px 12px;border:1px solid #3F5B44;border-radius:6px;background:#F3F1EA;color:#22261F;font-size:13px;line-height:1.7}.houle-backorder-note[hidden]{display:none!important}';
  function addStyle() {
    if (document.getElementById('houle-backorder-style')) return;
    var s = document.createElement('style'); s.id = 'houle-backorder-style'; s.textContent = CSS;
    document.head.appendChild(s);
  }
  function fix() {
    document.querySelectorAll('[data-button-content="pre-order"] .btn__text').forEach(function (e) {
      if (e.textContent !== BTN) e.textContent = BTN;
    });
    document.querySelectorAll('.label--pre-order').forEach(function (e) {
      if (e.textContent !== LBL) e.textContent = LBL;
    });
    document.querySelectorAll('.product-page-info__button-add-to-cart').forEach(function (w) {
      var b = w.querySelector('[data-js-product-button-add-to-cart]');
      if (!b) return;
      var n = w.nextElementSibling;
      if (!n || !n.classList.contains('houle-backorder-note')) {
        n = document.createElement('div'); n.className = 'houle-backorder-note'; n.innerHTML = NOTE;
        w.parentNode.insertBefore(n, w.nextSibling);
      }
      var on = b.getAttribute('data-button-status') === 'pre-order';
      if (n.hidden === on) n.hidden = !on;
    });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fix(); }); }
  function start() {
    addStyle(); fix();
    new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-button-status', 'class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
